<template lang="pug">
  .dashboard-inner.xs-f-small.max-at-tweak.narrow-modal-body
    SectionTitle(text="Replace Payment Method" data-mr-ass="replace-payment-modal").app-modal-title
    .msg This payment method is currently in use for the following auto-deliver{{suffix}}:
    .row(v-for="sub in profileToDelete.subs" :key="sub.id")
      .row.prod(v-for="item in sub.items")
        .xs-12.prod-info
          p
            span.upper.bold &#183;  {{ item.product_type_name }}&nbsp;
            span {{ item.product_name }}

    .row(v-if="moreThanOneProfile")
      hr
      .xs-12.msg Select a different subscription payment method:

      .xs-12.profiles
        .row(v-for="profile in profiles" v-if="profile.paymentProfileId != profileToDelete.paymentProfileId")
          .choice.xs-12
            .mr-radio(:class="{ 'selected': profile == selectedProfile } " data-mr-ass="different-sub-payment")
              input(type="radio" v-model="selectedProfile" :value="profile")

            .profile
              PaymentProfile(:profile="profile" :key="profile.paymentProfileId")

    .row(v-else)
      p Add another payment method:
      form(@submit="onSubmit")
        .row
          .xs-12
            PaymentEditInputs(:v="$v")

        .row(v-if="!editProfileForm.same_as_shipping")
          .xs-12
            AddressEditInputs(:v="$v")

    .row
      SubmitButtons(
        submit-text="Replace Payment Method"
        :submit-method="onSubmit"
        :submit-disabled="savingProfile"
        cancel-text="Cancel"
        :cancel-method="onCancel"
      )

</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import SubmitButtons from '../SubmitButtons';
  import PaymentEditInputs from './PaymentEditInputs';
  import AddressEditInputs from '../AddressBook/AddressEditInputs';
  import PaymentProfile from "./PaymentProfile";
  import SectionTitle from "../SectionTitle";

  export default {
    name: "PaymentDeleteHasSubsModal",
    components: {
      SectionTitle,
      PaymentProfile,
      SubmitButtons,
      PaymentEditInputs,
      AddressEditInputs
    },

    data() {
      return {
        selectedProfile: {}
      }
    },

    computed: {
      ...mapState('payments', [
        'profiles',
        'savingProfile',
        'profileToDelete',
        'editProfileForm',
        'profileFormValidators'
      ]),

      ...mapState('addressBook', [
        'editAddressForm',
        'addressFormValidators'
      ]),

      moreThanOneProfile() {
        return this.profiles.length > 1;
      },

      suffix() {
        if (!this.profileToDelete.subs) {
          return;
        }

        return this.profileToDelete.subs.length > 1 ? 'ies' : 'y';
      },
    },

    mounted() {
      //- when user is trying to delete their last payment that
      //- is associated with subs we require to enter a new
      //- replacement payment profile (this modal is shown only when user
      // tries to delete a profile with associated subs)
      if (!this.moreThanOneProfile) {
        this.populateEditProfileForm();
      }
    },

    methods: {
      ...mapActions('modal', ['hideModal']),
      ...mapActions('payments', [
        'populateEditProfileForm',
        'deleteProfileWithSubReplace'
      ]),

      onSubmit() {
        //- if there is more than one profile customer has to select one
        if (this.moreThanOneProfile && !this.selectedProfile.paymentProfileId) {
          return this.$store.dispatch('notifyWarn', 'Please select payment method to replace for all auto-deliveries.');
        }

        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.deleteProfileWithSubReplace(this.selectedProfile.paymentProfileId);
        this.hideModal();
      },

      onCancel() {
        this.hideModal();
        this.cleanUp();
      },

      cleanUp() {
        this.$store.commit('payments/clearEditProfileForm');
        this.$store.commit('addressBook/clearEditAddressForm');
      }
    },

    validations() {
      //- no validation necessary if user has more than one parofile
      if (this.moreThanOneProfile) {
        return {};
      }

      var editProfileForm = this.profileFormValidators;
      var editAddressForm = this.addressFormValidators;
      //- no need to validate address form if billing address same as shipping
      if (this.editProfileForm.same_as_shipping) {
        return { editProfileForm };
      } else {
        return { editProfileForm, editAddressForm };
      }
    }
  }
</script>

<style scoped lang="stylus">
  .msg
    padding 1em 0 1.5em

  .prod
    padding-bottom 1em

  .prod-img
    img
      width 100%

  .prod-info
    padding-left 0.5em

    p
      padding-bottom 0.5em

  hr
    padding-bottom 1em

  .profiles
    padding 0 0 2em 0

  .choice
    position relative
    padding-left 2em
    padding-bottom 2em

    .mr-radio
      position absolute
      top 0
      left 0

  .new-profile-btn
    margin-bottom 2em

  .profile-edit-form
    margin-bottom 1.5em
</style>